import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/layout/Layout';
import TrackCard from '../components/common/TrackCard';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { COURSES } from '../i18n';

const TracksPage = () => {
  const { t } = useTranslation();
  const { tracks } = useApp();
  const { user } = useAuth();
  
  // Get current course info for dynamic text
  const currentCourse = COURSES[user?.selected_course || 'pt-en'];
  const targetLanguage = currentCourse?.targetLanguage || 'inglês';
  const firstTrack = tracks[0];

  return (
    <Layout title={t('tracks.title')} showBack>
      <div className="px-4 py-6 space-y-6">
        {/* Header */}
        <div className="space-y-1">
          <h1 className="font-display text-2xl font-bold">{t('tracks.heading')}</h1>
          <p className="text-muted-foreground">
            {t('tracks.subtitle', { language: targetLanguage })}
          </p>
        </div>

        {/* Tracks Grid */}
        <div className="space-y-4" data-testid="tracks-list">
          {tracks.map(track => (
            <TrackCard key={track.id} track={track} />
          ))}
        </div>

        {/* Info */}
        <div className="p-4 rounded-xl bg-muted/50 text-center">
          <p className="text-sm text-muted-foreground">
            {t('tracks.tip', { trackName: firstTrack?.title || 'Daily Life' })}
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default TracksPage;
